import * as d3Base from 'd3'
import { weightedVoronoi } from 'd3-weighted-voronoi' 
import { voronoiMap } from 'd3-voronoi-map' 
import { voronoiTreemap } from 'd3-voronoi-treemap'
import Chart from '../chart'
import seedrandom from 'seedrandom'

import './VoronoiChart.css'

import migrantOrigin from '../../../assets/data/migrantOrigin_en.json';

const d3 = { ...d3Base, weightedVoronoi, voronoiMap, voronoiTreemap }

export default class VoronoiChart extends Chart {
  create() {
    this.svg = super.createRoot();
    this.main = this.svg.append('g')
      .attr('class', 'main');
    
    /*this.voronoi = this.svg.append('g')
      .attr('class', 'voronoi');

    this.labels = this.svg.append('g')
      .attr('class', 'labels');*/
  }

  // Main D3 rendering, that should be redone when the data updates.
  update(state) {
    if (JSON.stringify(state) !== JSON.stringify(this.state)) {
      this.drawVoronoi(state);
    }
  }

  drawVoronoi(state) {
    const migrants = d3.nest()
      .key(d => d.continent)
      .key(d => d.subContinent)
      .entries(migrantOrigin)
    const nestedPopulation = 
      {key: 'migrants', values: migrants}
    const migrantHierarchy = d3.hierarchy(nestedPopulation, d => d.values)
      .sum(d => d.population)

    const size = Math.min(this.props.width / 3, this.props.height)
    const ellipse = d3
      .range(100)
      .map(i => [
        (size * (1 + 0.99 * Math.cos((i / 50) * Math.PI))) / 2,
        (size * (1 + 0.99 * Math.sin((i / 50) * Math.PI))) / 2
      ])

    var myprng = seedrandom(51);
    var voronoiTreeMap = d3.voronoiTreemap()
      .prng(myprng)
      .clip(ellipse);
    
    voronoiTreeMap(migrantHierarchy);
    this.colorHierarchy(migrantHierarchy);
    
    var allNodes = migrantHierarchy.descendants()
      .sort((a,b) => b.depth - a.depth)
      .map((d, i) => Object.assign({}, d, {id: i}) );
    
    var hoveredShape = null;
    this.voronoi = this.main.selectAll('.voronoi')
      .data([3, 2, 1])
      .enter()
      .append('g')
      .attr('class', 'voronoi')

    const voronoiEnter = this.voronoi.selectAll('path')
      .data(d => allNodes.map(n => ({ ...n, level: d })))
      .enter()

    voronoiEnter.append('path')
      .attr('d', d => "M" + d.polygon.join("L") + "Z")
      .style('fill', d => d.parent ? d.parent.color : d.color)
      .attr("stroke", "white")
      .attr("stroke-width", 0)
      .style('fill-opacity', d => d.depth === d.level ? 1 : 0)
      .attr('pointer-events', d => d.depth === d.level ? 'all' : 'none')
      .on('mouseenter', d => {
        var label = this.voronoi.select(`.label-${d.id}-${d.level}`);
        label.attr('opacity', 1)
      })
      .on('mouseleave', d => {
        var label = this.voronoi.select(`.label-${d.id}-${d.level}`);
        label.attr('opacity', 0)
      })
      .transition()
      .duration(1000)
      .attr("stroke-width", d => 7 - d.depth*2)
      .style('fill', d => d.color);

    voronoiEnter.append('text')
      .attr('class', d => `voronoiLabel label-${d.id}-${d.level}`)
      .attr('text-anchor', 'middle')
      .attr("transform", d => "translate("+[d.polygon.site ? d.polygon.site.x : 0, d.polygon.site ? d.polygon.site.y+6 : 0]+")")
      .text(d => d.data.key || d.data.country) 
      .attr('opacity', d => d.data.key === hoveredShape ? 1 : 0)
      .attr('cursor', 'default')
      .attr('pointer-events', 'none')
      .attr('fill', 'black')

    this.voronoi
      .transition()
      .delay(1000)
      .duration(1000)
      .attr('transform', d => `translate(${(((this.props.width / 3) - size) / 2) + (Math.min(d-1, 1) * this.props.width / 3)}, 0)`)
      .transition()
      .duration(1000)
      .attr('transform', d => `translate(${(((this.props.width / 3) - size) / 2) + ((d-1) * this.props.width / 3)}, 0)`)
  }

  continentColor = (continent) => {
    var colors = {
      "Europe": "#2196F3",
      "Africa": "#E91E63",
      "Asia": "#FFEB3B",
      "South America": "#F44336",
      "North America": "#D32F2F",
      "Oceania": "#009688",
      "Unknown": "lightgrey"
    };
    return colors[continent];
  }

  colorHierarchy = (hierarchy) => {
    if(hierarchy.depth === 0) {
      hierarchy.color = 'white';
    } else if(hierarchy.depth === 1){
      hierarchy.color = this.continentColor(hierarchy.data.values[0].values[0].colorId);
    } else {
      hierarchy.color = hierarchy.parent.color;
    }
    if(hierarchy.children) {
      hierarchy.children.forEach( child => this.colorHierarchy(child))
    } 
  }
}


